import { PaginationQuery } from "../../types";
import { useApi } from "../api";
import { createAdminCrudApi } from "../createAdminCrudApi";
import {
  InsertScrewDiameterBody,
  ScrewDiameter,
  SearchScrewDiametersResponse,
  UpdateScrewDiameterBody,
} from "./types/screwDiameters";
import { SCREW_CONNECTOR_ADMIN_URL } from "./screwConnectorAdminUrl";
import { SCREW_CONNECTOR_URL } from "./screwConnectorUrl";

export const useScrewConnectorScrewDiametersApi = () => {
  const api = useApi();
  // The calculator reads the screw diameters too.
  const crud = createAdminCrudApi<SearchScrewDiametersResponse, InsertScrewDiameterBody, UpdateScrewDiameterBody>(
    api,
    SCREW_CONNECTOR_ADMIN_URL,
    "screw_diameters",
    [SCREW_CONNECTOR_URL],
  );

  return {
    useScrewDiameters: (query: PaginationQuery, signal: AbortSignal, screwFamilyId?: string) =>
      crud.useSearch(query, signal, { screwFamilyId }),
    getScrewDiameters: (query: PaginationQuery, signal: AbortSignal, screwFamilyId?: string) =>
      crud.search(query, signal, { screwFamilyId }),
    getScrewDiameterById: (id: string, signal: AbortSignal) =>
      api.get<ScrewDiameter>({ url: `${SCREW_CONNECTOR_ADMIN_URL}/screw_diameters/${id}`, signal }),
    insertScrewDiameter: crud.insert,
    updateScrewDiameter: crud.update,
    deleteScrewDiameter: crud.remove,
  };
};

export default useScrewConnectorScrewDiametersApi;
